import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as RadixSwitch from '@radix-ui/react-switch';
import { useState } from 'react';
import styles from './Switch.module.css';
/**
 * L'état se lit sans la couleur : position du curseur, piste pleine ou
 * creuse, et un pictogramme sur le curseur (coche, barre, croix, cadenas,
 * indicateur d'attente).
 */
export function Switch({ label, id, labelVisible = true, tone = 'default', locked = false, pending = false, checked, defaultChecked, onCheckedChange, disabled, ...rest }) {
    // Non contrôlé : on suit l'état pour afficher le bon pictogramme.
    const [interne, setInterne] = useState(defaultChecked ?? false);
    const actif = checked ?? interne;
    const icone = pending
        ? 'attente'
        : locked
            ? 'cadenas'
            : actif
                ? 'coche'
                : tone === 'danger'
                    ? 'croix'
                    : 'barre';
    return (_jsxs("label", { className: styles.label, htmlFor: id, children: [_jsx(RadixSwitch.Root, { className: styles.root, id: id, checked: checked, defaultChecked: defaultChecked, onCheckedChange: (valeur) => {
                    setInterne(valeur);
                    onCheckedChange?.(valeur);
                }, disabled: disabled || locked, "data-tone": tone === 'danger' ? 'danger' : undefined, "data-locked": locked ? '' : undefined, "aria-busy": pending || undefined, ...rest, children: _jsx(RadixSwitch.Thumb, { className: styles.thumb, children: _jsx(Pictogramme, { icone: icone }) }) }), _jsx("span", { className: labelVisible ? undefined : styles.texteMasque, children: label })] }));
}
const TRACES = {
    coche: 'M3.5 8.5l3 3 6-6.5',
    barre: 'M4 8h8',
    croix: 'M4.5 4.5l7 7M11.5 4.5l-7 7',
    cadenas: 'M5 7.5V6a3 3 0 016 0v1.5M4 7.5h8v5.5H4z',
};
function Pictogramme({ icone }) {
    return (_jsx("svg", { className: icone === 'attente' ? `${styles.icone} ${styles.attente}` : styles.icone, "data-icone": icone, viewBox: "0 0 16 16", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", focusable: "false", children: icone === 'attente' ? _jsx("path", { d: "M8 2.5a5.5 5.5 0 105.5 5.5" }) : _jsx("path", { d: TRACES[icone] }) }));
}
//# sourceMappingURL=Switch.js.map